import { render, staticRenderFns } from "./manage-users.vue?vue&type=template&id=3fb4df4d&"
import script from "./manage-users.vue?vue&type=script&lang=js&"
export * from "./manage-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports